export default __webpack_public_path__ + "static/media/iced_red_bean_drink_thumbnail.43077e00.JPG";